import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SignUpEmail, SignUpPassword } from './components';

export const SignUpPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleBack = () => setEmail('');
  const handleComplete = useCallback(() => navigate('/login'), [navigate]);

  return email === '' ? (
    <SignUpEmail onComplete={setEmail} />
  ) : (
    <SignUpPassword email={email} onBack={handleBack} onComplete={handleComplete} />
  );
};
